<template>
  <v-chip :color="chipColor">
    {{ opinionAgreement }}
  </v-chip>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'OpinionAgreement',
  props: {
    opinion: {
      type: Object,
      required: true,
    },
  },
  computed: {
    opinionAgreement() {
      if (this.opinion.agreementRank.votes === 0) {
        return '-';
      }
      return `${Math.round(this.opinion.agreementRank.agreement)}%`;
    },
    chipColor() {
      if (this.opinion.agreementRank.agreement === 0) {
        return undefined;
      } else if (this.opinion.agreementRank.agreement === 50) {
        return 'blue-grey lighten-2';
      } else if (this.opinion.agreementRank.agreement > 50) {
        return 'success';
      } else {
        return 'error';
      }
    },
  },
});
</script>
